module.exports = __webpack_public_path__ + "img/mixerTruck-blue.ac43610d.svg";